import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { endless: false, slideInClass: 'flashes--slide-in', slideOutClass: 'flashes--slide-out' }

  connect () {
    setTimeout(() => {
      this.element.classList.remove(this.slideInClassValue);
    }, 30);

    if (!this.endlessValue) {
      setTimeout(() => {
        this.element.classList.add(this.slideOutClassValue);
      }, 4000);
    }
  }

  remove () {
    if (this.element.classList.contains(this.slideOutClassValue)) { this.element.remove(); }
  }
}
